import MobilefrndImg from "../svg/MobileFriendlyimg.svg"
const MobilefrndImgs = () => {
    return (
   
  <img src={MobilefrndImg} />


    )
  }
  export default MobilefrndImgs;